import { useCallback, useState } from "react";
import authService from "../services/authentication.service";
import useAlert from "./useAlert";
import { IResult } from "../models/results/result.interface";
import { useNavigate } from "react-router-dom";
import { RouteConstants } from "../constants";

const useResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [passwordSubmitted, setPasswordSubmitted] = useState(false);
  const [tokenInvalid, setTokenInvalid] = useState(false);

  const {
    showErrorAlert,
    alertProps,
    alertMessage,
    getAlertMessageAndSupportContent,
  } = useAlert();

  const resetPassword = useCallback(
    async (token: string, newPassword: string): Promise<IResult> => {
      try {
        setLoading(true);

        const { success, errorCode } = await authService.resetPassword(
          token,
          newPassword
        );
        if (!success && errorCode) {
          //Handle Failure
          if (Number(errorCode) === 500 || Number(errorCode) === 401) {
            const { message, support } = getAlertMessageAndSupportContent(
              "RESET_PASSWORD.CUSTOMER_SUPPORT_CONTACT",
              "An error occurred while trying to update your password.<br></br>Please contact SmartHeart customer support.",
              {
                br: () => <br></br>,
              },
              errorCode
            );
            showErrorAlert(message, {
              ...support,
              showLink: false,
              onClose: () => {
                Number(errorCode) === 500 &&
                  navigate(RouteConstants.FORGOT_PASSWORD_PATH, {
                    replace: true,
                  });
              },
            });
            Number(errorCode) === 401 && setTokenInvalid(true);
            return { success, errorCode };
          }
          const supportedErrorCodes = [400];
          if (supportedErrorCodes.includes(Number(errorCode))) {
            return { success, errorCode };
          }
        }
        //Handle Success
        setPasswordSubmitted(true);
        return { success: true };
      } finally {
        setLoading(false);
      }
    },
    [getAlertMessageAndSupportContent, showErrorAlert]
  );

  return {
    resetPassword,
    loading,
    alertProps,
    alertMessage,
    passwordSubmitted,
    setPasswordSubmitted,
    tokenInvalid,
  };
};
export default useResetPassword;
